import styled from 'styled-components';

export const Content = styled.div`
  float: left;
  width: 100%;
  padding: 20px;

  @media (max-width: 1024px) {
    overflow-x: hidden;
  }
`;

export const LoadArea = styled.div`
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const Cards = styled.div`
  float: left;
  width: 100%;
  padding: 0 15px;
  margin-bottom: 20px;

  main {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0px;
    float: left;
    width: 100%;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    width: 100%;
    padding: 15px;
    margin-bottom: 0px;

    main {
      flex-direction: column;
      width: 100%;
    }
  }
`;

export const Card = styled.div`
  float: left;
  width: 25%;
  padding: 5px;
  cursor: pointer;
  transition: all 0.5s ease;

  &:hover {
    div {
      background: ${({ theme }) => theme.colors.LIGHT4} !important;
    }
  }

  &.card-20 {
    width: 20%;
  }

  div {
    background: ${({ theme }) => theme.colors.LIGHT1};
    border-radius: 8px;
    border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    padding: 15px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    float: left;
    width: 100%;
    height: 100%;

    main {
      display: flex;
      flex-direction: column;
      float: left;
      padding: 0 15px 0 0;
      flex: 1;
      display: flex;

      h2 {
        color: ${({ theme }) => theme.colors.TEXT4};
        font-size: 14px;
        margin: 0 0 5px 0;
      }

      h1 {
        color: ${({ theme }) => theme.colors.TEXT1};
        font-size: 26px;
      }

      p {
        width: 100%;
        float: left;
        display: flex;
        flex-direction: column;
        margin: 10px 0 0 0;
        color: ${({ theme }) => theme.colors.TEXT4};
        font-size: 10px;
      }
    }
  }

  &:nth-child(odd) {
    div {
      background: ${({ theme }) => theme.colors.LIGHT1};
    }
  }

  span {
    color: ${({ theme }) => theme.colors.TEXT1};
    text-decoration: none;
    font-size: 10px;
    font-weight: 700;
    border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    border-radius: 16px;
    height: 32px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 1024px) {
    width: 100%;
    padding: 0px;
    margin: 0 0px 15px 0;

    &.card-20 {
      width: 100%;
    }

    &:last-child {
      margin-bottom: 0px;
    }

    div {
      padding: 20px 10px;
      justify-content: flex-start;
      align-items: flex-start;
      border-radius: 10px;

      i {
        margin-left: 40px;
      }

      main {
        h1 {
          font-size: 16px;
          font-weight: 700;
          text-align: left;
        }

        h2 {
          font-size: 14px;
          font-weight: 700;
          text-align: left;
        }

        p {
          font-size: 12px;
          font-weight: 700;
          text-align: left;
        }
      }
    }
  }
`;

export const Boards = styled.div`
  float: left;
  width: 100%;
  padding: 0 20px;
  display: flex;
  flex-direction: row;

  @media (max-width: 1024px) {
    padding: 0 10px;
    flex-direction: column;
  }
`;

export const SpaceHorizontal = styled.div`
  float: left;
  width: 100%;
  height: 20px;
  display: flex;
  flex-direction: row;

  @media (max-width: 1024px) {
    padding: 0;
  }
`;

export const Space = styled.div`
  float: left;
  width: 40px;
  display: flex;
  flex-direction: row;

  @media (max-width: 1024px) {
    padding: 0;
  }
`;

export const Board = styled.div`
  float: left;
  width: 100%;
  background: ${({ theme }) => theme.colors.LIGHT1};
  border-radius: 8px;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  padding: 0px;

  header {
    width: 100%;
    float: left;
    padding: 20px;
    margin: 0 0 0px 0;
    align-items: center;
    display: flex;
    font-size: row;
    justify-content: space-between;

    h1 {
      display: flex;
      align-items: center;

      i {
        margin-right: 10px;
      }

      div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        span {
          color: ${({ theme }) => theme.colors.TEXT1};
          font-size: 20px;
        }

        small {
          background: ${({ theme }) => theme.colors.LIGHT1};
          font-weight: 700;
          color: ${({ theme }) => theme.colors.TEXT1};
          font-size: 10px;
          border-radius: 5px;
          padding: 3px 5px;
        }

        p {
          font-size: 10px;
          color: ${({ theme }) => theme.colors.TEXT4};
        }
      }
    }

    button {
      background: none;
      cursor: pointer;
      transition: all 0.5s ease;

      &:hover {
        opacity: 0.7;
        transform: rotate(-180deg);
      }
    }
  }

  main {
    float: left;
    width: 100%;
  }

  @media (max-width: 1024px) {
    padding: 0px;

    border-radius: 6px;
    margin: 0 0 30px 0;

    header {
      padding: 15px 10px;
      margin: 0px;

      h1 {
        div {
          span {
            font-size: 12px;
          }

          small {
            font-size: 8px;
          }
        }
      }
    }
  }
`;

export const Percentages = styled.div`
  width: 100%;
  float: left;
  display: flex;
  flex-direction: column;
  padding: 0 15px 15px 15px;
`;

export const Percentage = styled.div`
  float: left;
  display: flex;
  flex-direction: column;
  margin: 0 0 20px 0;

  &:last-child {
    margin-bottom: 0px;
  }

  div {
    width: 100%;
    float: left;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    span {
      font-size: 10px;
      font-weight: 700;
      color: ${({ theme }) => theme.colors.TEXT1};
    }

    small {
      font-size: 10px;
      color: ${({ theme }) => theme.colors.TEXT4};
      margin: 3px 0 0 0;
    }
  }

  p {
    margin: 0px;
    width: 100%;
    float: left;
    height: 15px;
    border-radius: 5px;
    background: ${({ theme }) => theme.colors.LIGHT1};
    overflow: hidden;
  }

  i {
    float: left;
    height: 15px;
    background: ${({ theme }) => theme.colors.ORANGE};
    opacity: 0.8;
    color: ${({ theme }) => theme.colors.TEXT2};
    font-size: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    text-decoration: none;
    font-style: normal;
    text-align: center;
  }

  @media (max-width: 1024px) {
    font-size: 10px;
    padding: 0px;
    width: auto;
  }
`;

export const Tag = styled.span`
  color: ${({ theme }) => theme.colors.TEXT1};
  text-decoration: none;
  font-size: 10px;
  font-weight: 700;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  border-radius: 16px;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Status = styled.span`
  color: ${({ theme }) => theme.colors.TEXT1};
  text-decoration: none;
  font-size: 10px;
  font-weight: 700;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  border-radius: 16px;
  height: 32px;
  padding: 0 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  i {
    float: left;
    width: 32px;
    height: 32px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-right: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  }

  span {
    float: left;
    height: 32px;
    display: flex;
    padding: 0 10px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  strong {
    border-left: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    float: left;
    height: 32px;
    display: flex;
    padding: 0 10px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`;

export const TypeTag = styled.div`
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  border-radius: 5px;
  padding: 5px 8px;
  color: ${({ theme }) => theme.colors.TEXT1};
  background-color: ${({ theme }) => theme.colors.LIGHT1};
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 10px;
    padding: 0px;
    width: auto;
  }
`;
